import { _isNaN } from './_setup.js';
import isNumber from './isNumber.js';

// Is the given value `NaN`?
export default function isNaN(obj) {
  return isNumber(obj) && _isNaN(obj);
}



//////////////////
// WEBPACK FOOTER
// ./~/_underscore@1.13.2@underscore/modules/isNaN.js
// module id = 532
// module chunks = 106